import { useSelector } from 'react-redux';
import useTexts from 'features/resolutionPanel/useTexts';
import { selectJourneyFilters } from 'features/resolutionPanel/middlePanel/auditLog/store/slice';
import { SR_TYPES, SR_TYPE_CODE_MAP } from 'features/TicketPanel/constants';
import { useSrById } from 'remote-state/ticketServiceHooks';
import { useWorkflowQuery } from '../../Workflows/api/workflowQueries';

const initializeTabs = ({ tabTexts, hasWorkflow, showTicketAsTab }) => {
  const newTabs = [];
  if (showTicketAsTab) newTabs.push(tabTexts.ticketDetailsTab);
  if (hasWorkflow) newTabs.push(tabTexts.workflowTab);
  newTabs.push(tabTexts.journeyTab, tabTexts.attachmentsTab);
  return newTabs;
};

function useInitializeTabs({ srId, tabTexts, showTicketAsTab }) {
  const { srType } = useSrById(srId).data ?? {};
  const hasWorkflow = Boolean(SR_TYPE_CODE_MAP[srType] !== SR_TYPES.incident);

  const tabs = useWorkflowQuery({
    srId,
    enabled: hasWorkflow,
    select: (data) =>
      initializeTabs({
        tabTexts,
        hasWorkflow: hasWorkflow && data?.phases?.length > 0,
        showTicketAsTab,
      }),
  });

  if (!hasWorkflow) {
    return {
      data: initializeTabs({
        tabTexts,
        hasWorkflow: false,
        showTicketAsTab,
      }),
      isLoading: false,
      isError: false,
    };
  }

  return tabs;
}

export const useTabs = ({ srId, showTicketAsTab }) => {
  const texts = useTexts();
  const { tab: currentSelectedTabIndex } = useSelector(selectJourneyFilters);
  const { data: tabs, isLoading } = useInitializeTabs({
    tabTexts: texts,
    srId,
    showTicketAsTab,
  });

  return {
    tabs,
    selectedTabIndex: currentSelectedTabIndex ?? 0,
    selectedTabName: tabs && tabs[currentSelectedTabIndex],
    isLoading,
  };
};
